export default {
    EDUCACAO : 1,
    SAUDE : 2,
}